import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from 'src/app/ceq/common/services/GenericServices';
import { ResponseJson, SingleResponseJson } from '../common/models/response';
import { ZonePT } from '../common/models/ZonePT.Model';
import { Employee } from '../common/models/Employee.Model';
import { HeatmapPoint } from './cut-pt-heatmap/cut-pt-heatmap.component';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private productModal: any;
  private zoneModal: any;
  private mapModal: any;

  constructor(
    private genericServ: GenericService
  ) { }

  /**La compulsa actual le cambia el estatus*/
  changeCutStatus(data: any): Observable<any> {
    let url = `cutpt/statuschange`;
    return this.genericServ.putRequest(url, {}, 0, data);
  }

  getCutPtData(unitid: number, fecha: any, type: any): Observable<any> {
    return this.genericServ.getRequest(`cutpt/${unitid}/${fecha}/${type}`, {});
  }

  /**Obtiene los reportes de efectividad y bitacora de chofer AS*/
  genCutPTReport(request: any): Observable<any> {
    return this.genericServ.postRequest(`cutpt/print/genCutPTReport`, {}, 0, request);
  }

  genMaxLimit(): Observable<any> {
    return this.genericServ.getRequest(`configuration/MaxCPtQty`, {}, 0);
  }

  genCutPTRepoCounter(CutId: string): Observable<any> {
    return this.genericServ.getRequest(`cutpt/print/GenCutPTRepoCounter/${CutId}`, {}, 0);
  }

  getContainerType(): Observable<any> {
    return this.genericServ.getRequest('containerlocationbyunit', {});
  }

  getContainerTypeCutPt(): Observable<any> {
    return this.genericServ.getRequest('containerlocationbyunit/cutType/PT', {});
  }

  createCut(unitid: number, fecha: any, type: any): Observable<any> {
    return this.genericServ.postRequest(`cutpt/${unitid}/${fecha}/${type}`, {}, 0, null);
  }

  cancelCut(cutId: any): Observable<any> {
    return this.genericServ.deleteRequest(`cutpt/${cutId}`, {}, 0);
  }

  saveDetail(adjust: any[]): Observable<any> {
    return this.genericServ.postRequest(`cutpt/saveDetail`, {}, 0, adjust);
  }

  statusCutPTChanges(CutId: string, status: string): Observable<any> {
    let url = `CutPt/statuschange/${CutId}/${status}`;
    return this.genericServ.putRequest(url, {}, 0, null);
  }

  setSign(cutId: string, type: string, sign: string, msg: string): Observable<any> {
    let url = `CutPt/setsign/${cutId}/${type}/${sign}/${msg}`;
    return this.genericServ.putRequest(url, {}, 0, null);
  }

  assignZones(ZoneCode: string, CounterId: string, CertifierId: string, CutId: string, CheckIndValid: boolean): Observable<any> {
    return this.genericServ.postRequest(`cutpt/assignZones/${ZoneCode}/${CounterId}/${CertifierId}/${CutId}/${CheckIndValid}`, {}, 0, null);
  }

  deleteAssignZone(ZoneCode: string, CounterId: string, CertifierId: string, CutId: string): Observable<any> {
    return this.genericServ.deleteRequest(`cutpt/deleteAssignZone/${ZoneCode}/${CounterId}/${CertifierId}/${CutId}`, {}, 0);
  }

  getZones(UnitId: number): Observable<ResponseJson<ZonePT>> {
    let url = "ZonesPt/ceve/" + UnitId;
    return this.genericServ.getRequest(url, {}, 0)
  }

  getAssingZones(UnitId: number, CutId: string): Observable<any> {
    let url = `cutpt/AssingZonesList/${CutId}/${UnitId}`;
    return this.genericServ.getRequest(url, {}, 0)
  }

  saveInventoryLoad(data: any, cutId: string, type: number, ceveId: number): Observable<any[]> {
    let url = `CutPt/saveinventoryload?cutId=${cutId}&type=${type}&ceveId=${ceveId}`;
    return this.genericServ.postRequest(url, {}, 0, data);
  }

  saveInventoryWmsLoad(cutId: string, ceveId: number): Observable<any[]> {
    let url = `CutPt/saveinventorywmsload?cutId=${cutId}&ceveId=${ceveId}`;
    return this.genericServ.postRequest(url, {}, 0, null);
  }

  getLogInventoryLoad(Org: number, UnitId: number, CutId: string): Observable<any[]> {
    let url = `log/${Org}/${UnitId}/${CutId}/logPT`;
    return this.genericServ.getRequest(url, {}, 0);
  }

  validateInventory(CutId: string): Observable<any> {
    let url = `CutPt/validInventory/${CutId}`;
    return this.genericServ.getRequest(url, {}, 0);
  }

  getCutPtLabelSerial(CutId: string, printQty: number): Observable<any> {
    let url = `cutpt/${CutId}/labelserial/${printQty}`;
    return this.genericServ.getRequest(url, {}, 0);
  }

  getCutPtCounters(cutId: string): Observable<Employee[]> {
    let url = `cutpt/${cutId}/counters`;
    return this.genericServ.getRequest(url, {}, 0);
  }

  getCutPtCertifiers(cutId: string): Observable<Employee[]> {
    let url = `cutpt/${cutId}/certifiers`;
    return this.genericServ.getRequest(url, {}, 0);
  }

  getHeatmapPoints(cutId: string): Observable<HeatmapPoint[]> {
    let url = `cutpt/${cutId}/heatmap/points`;
    return this.genericServ.getRequest(url, {}, 0);
  }

  getValidateWms(Org: number, UnitId: number): Observable<boolean> {
    let url = `ceve/ValidateWms/${UnitId}/${Org}`;
    return this.genericServ.getRequest(url, {}, 0);
  }

  lapseCut(cutId: string): Observable<any> {
    let url = `cutpt/lapse`;
    return this.genericServ.postRequest(url, {}, 0, null);
  }

  /**
   * Get a cutpt printed in PDF format
   * @param cutId 
   * @returns 
   */
  getCutPtPrintedPdf(cutId: string): Observable<any> {
    return this.genericServ.getPdfRequest(`cutpt/printdoc/${cutId}`, {}, 0);
  }

  /** MODALS */
  openProductModal() {
    this.productModal.open({ backdrop: 'static', keyboard: false });
  }

  addProductModal(modalItem: any) {
    this.productModal = modalItem;
  }

  openZoneModal() {
    this.zoneModal.open();
  }

  addZoneModal(modalItem: any) {
    this.zoneModal = modalItem;
  }

  addMapModal(mapModal: any) {
    this.mapModal = mapModal;
  }

  validateOPenModal(): boolean {
    if (this.productModal.isModalOpen) {
      return true;
    } else {
      return false;
    }
  }

  openMapModal() {
    this.mapModal.open();
  }

  refreshMapModal() {
    this.mapModal.refresh();
  }

}
